import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import Pagination from "@/components/Pagination";
import { ShieldCheck, Search } from "lucide-react";

const ACTION_TONE = {
  SaleConfirmed: "text-[#15803D] bg-[#DCFCE7]", PaymentReceived: "text-[#15803D] bg-[#DCFCE7]",
  ExpenseApproved: "text-[#B45309] bg-[#FEF3C7]", TransactionVoided: "text-[#B91C1C] bg-[#FEE2E2]",
  StockMovement: "text-[#0E7490] bg-[#E0F2FE]", InventoryAdjusted: "text-[#0E7490] bg-[#E0F2FE]",
  CashOpened: "text-[#2563EB] bg-[#EFF6FF]", CashClosed: "text-[#2563EB] bg-[#EFF6FF]",
  create: "text-[#2563EB] bg-[#EFF6FF]", update: "text-[#B45309] bg-[#FEF3C7]",
};

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const filtered = rows.filter((r) => JSON.stringify(r).toLowerCase().includes(q.toLowerCase()));
  const paged = filtered.slice((page - 1) * 10, page * 10);
  const onSearch = (v) => { setQ(v); setPage(1); };

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><h1 className="text-2xl md:text-3xl font-bold font-head text-[#16324F] tracking-tight flex items-center gap-2"><ShieldCheck className="w-6 h-6" /> Journal d'audit</h1>
          <p className="text-sm text-[#64748B] mt-1">Événements immuables · horodatés · attribués</p></div>
        <div className="relative w-full sm:w-72">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <input value={q} onChange={(e) => onSearch(e.target.value)} className="inp pl-9" placeholder="Rechercher…" data-testid="audit-search" />
        </div>
      </div>

      <div className="card overflow-x-auto">
        <table className="w-full"><thead><tr>
          <th className="th">Horodatage</th><th className="th">Acteur</th><th className="th">Action</th>
          <th className="th">Objet</th><th className="th">Détail</th>
        </tr></thead><tbody>
          {paged.map((r) => (
            <tr key={r.id} className="row" data-testid={`audit-row-${r.id}`}>
              <td className="td text-xs whitespace-nowrap">{fmtDate(r.timestamp)}</td>
              <td className="td font-medium">{r.actor_name || "—"}</td>
              <td className="td"><span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${ACTION_TONE[r.action] || "text-[#475569] bg-[#F1F5F9]"}`}>{r.action}</span></td>
              <td className="td text-[#64748B]">{r.object_type}</td>
              <td className="td text-xs font-mono text-[#64748B] max-w-[280px] truncate">{r.after ? JSON.stringify(r.after) : "—"}</td>
            </tr>
          ))}
          {filtered.length === 0 && <tr><td colSpan={5} className="td text-center py-10 text-[#94A3B8]">Aucun événement</td></tr>}
        </tbody></table>
      </div>
      <Pagination page={page} setPage={setPage} total={filtered.length} />
    </div>
  );
}
